module.exports = __webpack_public_path__ + "static/media/landscape12.15423dbc.jpg";